import { useEffect, useState } from "react"
import * as turf from "@turf/turf"

import {
  defaultSpeedProfileData,
  defaultConsumptionProfile,
  defaultPlannerVesselSettings,
  DEFAULT_BUNKER_PRICES,
} from "@/config/defaults"
import { nowUtc } from "@/utils/appNow"

// Formular- und Rechenzustand des VoyagePlanners (Route, Start/Ziel,
// Kalkulator, Profile, ETA). Reiner State-Besitz — die Handler bleiben beim
// Wiring in MainComponent.
export function usePlannerFormState() {
  const [draftPlannerVesselSettings, setDraftPlannerVesselSettings] = useState(
    {},
  )
  const [voyagePlannerPoints, setVoyagePlannerPoints] = useState(
    turf.featureCollection([]),
  )
  // The planner's current draft slot, published for the map layers.
  const [plannerDraftSlot, setPlannerDraftSlot] = useState({
    routeId: null,
    showSketch: false,
    sketchView: false,
  })
  const [voyageActive, setVoyageActive] = useState(false)

  const [startInput, setStartInput] = useState("")
  const [finishInput, setFinishInput] = useState("")
  const [startEndpoint, setStartEndpoint] = useState(null)
  const [finishEndpoint, setFinishEndpoint] = useState(null)
  const [startError, setStartError] = useState(false)
  const [finishError, setFinishError] = useState(false)
  const [calculatorDepartureTime, setCalculatorDepartureTime] = useState(() =>
    nowUtc().startOf("minute"),
  )

  // A departure in the past is never valid — whenever the value slips behind
  // the current minute (default "now" aging out, or a stale pick), pull it up.
  useEffect(() => {
    const id = setInterval(() => {
      const nowMinute = nowUtc().startOf("minute")
      setCalculatorDepartureTime((prev) =>
        prev?.isValid?.() && prev.isBefore(nowMinute) ? nowMinute : prev,
      )
    }, 1_000)
    return () => clearInterval(id)
  }, [])
  const [calculatorBasespeed, setCalculatorBasespeed] = useState(13)
  const [profileOptions, setProfileOptions] = useState([])
  const [selectedProfile, setSelectedProfile] = useState(null)
  const [speedProfileData, setSpeedProfileData] = useState(
    defaultSpeedProfileData,
  )
  const [consumptionProfileData, setConsumptionProfileData] = useState(
    defaultConsumptionProfile,
  )
  const [plannerVesselSettings, setPlannerVesselSettings] = useState(
    defaultPlannerVesselSettings,
  )
  const [etaResponse, setEtaResponse] = useState(false)
  const [routeConsumption, setRouteConsumption] = useState(false)
  const [applyRnwSafety, setApplyRnwSafety] = useState(false)
  const [applyEca, setApplyEca] = useState(false)
  const [avoidHra, setAvoidHra] = useState(false)
  const [avoidJwla, setAvoidJwla] = useState(false)
  const [avoidCaa, setAvoidCaa] = useState(false)

  // Fuel features (all optional; empty = feature not sent). Prices live in
  // VoyageSpecTab, currentDraft in ConsumptionTab. CII has no own state: core
  // derives it from the vessel master data (vessel.id in the request).
  const [bunkerPrices, setBunkerPrices] = useState(DEFAULT_BUNKER_PRICES)
  const [currentDraft, setCurrentDraft] = useState("")

  return {
    draftPlannerVesselSettings,
    setDraftPlannerVesselSettings,
    voyagePlannerPoints,
    setVoyagePlannerPoints,
    plannerDraftSlot,
    setPlannerDraftSlot,
    voyageActive,
    setVoyageActive,
    startInput,
    setStartInput,
    finishInput,
    setFinishInput,
    startEndpoint,
    setStartEndpoint,
    finishEndpoint,
    setFinishEndpoint,
    startError,
    setStartError,
    finishError,
    setFinishError,
    calculatorDepartureTime,
    setCalculatorDepartureTime,
    calculatorBasespeed,
    setCalculatorBasespeed,
    profileOptions,
    setProfileOptions,
    selectedProfile,
    setSelectedProfile,
    speedProfileData,
    setSpeedProfileData,
    consumptionProfileData,
    setConsumptionProfileData,
    plannerVesselSettings,
    setPlannerVesselSettings,
    etaResponse,
    setEtaResponse,
    routeConsumption,
    setRouteConsumption,
    applyRnwSafety,
    setApplyRnwSafety,
    applyEca,
    setApplyEca,
    avoidHra,
    avoidJwla,
    avoidCaa,
    setAvoidHra,
    setAvoidJwla,
    setAvoidCaa,
    bunkerPrices,
    setBunkerPrices,
    currentDraft,
    setCurrentDraft,
  }
}
